<template>
    <div>
        <PageTitle :pages="pages" :title="titles.organisationsList"/>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{title}}</h4>
                <Tab :currentTab="tabs[0]" :currentTabComponent="currentTab" :form="subscription"
                     :role="role"
                     :show="showTab"
                     :tabs="tabs"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import PageTitle from '../common/PageTitle';
    import {titles} from '../../utils/general/titles.js';
    import {name} from '../../utils/general/routers.js';
    import {roles} from '../../utils/general/roles';
    import Tab from '../common/Tab';
    import {subscription} from '../shared/models/subscription';

    export default {
        name: 'Form',
        components: {PageTitle, Tab},
        data() {
            return {
                titles,
                roles,
                currentTab: null,
                showTab: true,
                title: titles.organisationAddExpression,
                pages: [],
                subscription: subscription(),
                tabs: [],
                role: this.$store.getters.role
            };
        },
        created() {
            if (this.$route.params.subscriptionItem) {
                this.$cookies.set('organisationDetailItem', this.$route.params.organisationItem);
                this.$cookies.set('packCountryDomainDetailItem', this.$route.params.packCountryDomainItem);
                this.$route.params.subscriptionItem.organisation = [];
                this.$route.params.subscriptionItem.packCountryDomain = [];
                this.$cookies.set('subscriptionItem', this.$route.params.subscriptionItem);
                this.$route.params.organisationItem = this.$cookies.get('organisationDetailItem');
                this.$route.params.packCountryDomainItem = this.$cookies.get('packCountryDomainDetailItem');
                this.$cookies.set('organisationItemIsEditable', this.$route.params.isEditable);
            }
            if (this.$cookies.isKey('subscriptionItem')
                && this.$cookies.isKey('organisationDetailItem') && this.$cookies.isKey('packCountryDomainDetailItem')) {
                this.title = titles.organisationEditExpression;
                this.subscription = this.$cookies.get('subscriptionItem');
                this.subscription.organisation = this.$cookies.get('organisationDetailItem');
                this.subscription.packCountryDomain = this.$cookies.get('packCountryDomainDetailItem');
                this.showTab = true;
            }
            if (this.role == this.roles.client) {
                this.tabs = [
                    {
                        name: 'Organisation',
                        component: 'OrganisationInfo'
                    },
                    {
                        name: 'Pack',
                        component: 'PackInfo'
                    }
                ];
            } else {
                this.tabs = [
                    {
                        name: 'Client',
                        component: 'ClientInfo'

                    },
                    {
                        name: 'Organisation',
                        component: 'OrganisationInfo'
                    },
                    {
                        name: 'Pack',
                        component: 'PackInfo'
                    }
                ];
            }


            if (this.$route.path.includes('organisation/update') && this.$route.params.organisationId) {
                this.currentTab = 'OrganisationInfo';
            } else {
                this.currentTab = this.$route.params.goToTab ? this.$route.params.goToTab : this.tabs[0].component;
            }
            this.tabSelected = this.tabs[0].component;
            this.pages.push(
                {
                    name: titles.organisations,
                    router: name.organisation,
                    active: false
                },
                {
                    name: this.title,
                    router: null,
                    active: true
                }
            );
        },
        validations: {
            subscription: {
                organisation: {required},
                packCountryDomain: {required}
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/appStyle.css';
</style>
